module.exports = __webpack_public_path__ + "media/images/event/image_01-08a9c22cc387375bf041a7176d11a5a0.png";